/* eslint-disable max-lines-per-function */
import { EventBus, Events } from "jiffy-store";

import initReviewListPhotos from "components/jiffy/reviews-list-photos/reviews-list-photos";
import "components/jiffy/review-property-box/review-property-box";

import "./reviews-list-item.scss";
import "./reviews-list-item-recommend/reviews-list-item-recommend.scss";

export default () => {
  const detailsLinks = Array.from(document.querySelectorAll(".js-display-details"));

  detailsLinks.forEach(button => {
    button.addEventListener("click", event => {
      event.preventDefault();
      button
        .closest(".reviews-list-item")
        .querySelector(".reviews-list-item__display-details")
        .classList.toggle("hide");
      button
        .closest(".reviews-list-item")
        .querySelector(".reviews-list-item__review-details")
        .classList.toggle("hide");
    });
  });

  const reviewVoteButtons = Array.from(
    document.querySelectorAll(".js-reviews-list-item__vote-action-button")
  );
  reviewVoteButtons.forEach(button => {
    button.addEventListener("click", () => {
      EventBus.publish(Events.SHOW_RECAPTCHA_MODAL, { button });
    });
  });

  const reviewTexts = Array.from(document.querySelectorAll(".js-review-readmore-container"));
  reviewTexts.forEach(text => {
    const { height } = { height: 144, ...text.dataset };
    if (text.offsetHeight > height) {
      const gradient = text.querySelector(".js-review-readmore-gradient");
      const classNames = [
        "reviews-list-item__readmore-collapsed",
        `reviews-list-item__readmore-collapsed--${height}`
      ];

      text.classList.add(...classNames);
      text.parentElement.querySelector(".js-review-readmore-button").classList.remove("hide");
      gradient.classList.remove("hide");

      const readMoreButtons = Array.from(
        text.parentElement.querySelectorAll(".js-review-readmore-button")
      );
      readMoreButtons.forEach(button => {
        button.addEventListener("click", event => {
          event.preventDefault();
          gradient.classList.toggle("hide");
          if (text.classList.contains(classNames[0])) {
            text.classList.remove(...classNames);
          } else {
            text.classList.add(...classNames);
          }
          readMoreButtons.forEach(currentButton => {
            currentButton.classList.toggle("hide");
          });
        });
      });
    }
  });

  initReviewListPhotos();
};
